<template>
  <div class="articleList">
    <div v-for="article in articleList" :key="article.id" class="item">
      <div class="article">
        <div class="title">
          <span @click="viewArticle(article.id)" class="articleName" href="javascript:;">{{article.title}}</span>
          <span v-if="article.categoryId" class="category">{{article.categoryName}}</span>
        </div>
        <div v-if="article.pictureUrl" class="insert-img" :style="{backgroundImage: 'url(' + article.pictureUrl + ')' }"></div>
        <div class="summary">
          <p>{{article.summary}}</p>
        </div>
        <div class="footer">
          <span>
            <a-icon type="fire" style="" />
            {{article.traffic}}
          </span>
          <span class="em"></span>
          <span>
            <a-icon type="heart" style="" />
            {{article.love}}
          </span>
          <span class="em"></span>
          <span style="color: #aaa;">{{article.createBy}}</span>
        </div>
      </div>
      <div v-if="article.pictureUrl" class="img" :style="{backgroundImage: 'url(' + article.pictureUrl + ')' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'articleList'
  ],
  methods: {
    viewArticle(id) {
      this.$router.push(`/article/${id}`)
    }
  },
}
</script>

<style scoped>
.item {
  display: flex;
  margin-top: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #2d2d2d;
}

.article {
  flex-grow: 1;
  padding-right: 1rem;
  display: flex;
  flex-direction: column;
}

.article .title .category {
  display: inline-block;
  background-color: #eee;
  border-radius: 2px;
  padding: 0 .5rem;
  margin: 0 .5rem;
  font-size: 1.1rem;
  background-color: #333;
  line-height: 1.5rem;
  color: #fff;
  padding-top: 1px;
}

.article .title .articleName {
  cursor: pointer;

}

.article .title {
  flex-grow: 0;
  font-size: 1.4rem;
  line-height: 2rem;
  color: #1890ff;
  margin-bottom: 1rem;
}

.item .img {
  flex-shrink: 0;
  width: 200px;
  height: 120px;
  /* background-image: url(http://aliyunoss.mldie.com/mldieblogimages/Snipaste_2020-07-17_05-26-58.png); */
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 2px;
}

.summary {
  flex-grow: 1;
}

.summary p {
  text-indent: 2;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.footer {
  flex-grow: 0;

}
.footer .em {
  position: relative;
  display: inline-block;
  width: 1px;
  height: 14px;
  background-color: #4b4b4b;
  top: 2px;
  margin: 0 2rem;
}
.insert-img {
  display: none;
}

@media screen and (max-width: 576px) {
  .img {
    display: none;
  }

  .insert-img {
    margin-bottom: 1rem;
    display: block;
    flex-shrink: 0;
    height: 170px;
    /* background-image: url(http://aliyunoss.mldie.com/mldieblogimages/Snipaste_2020-07-17_05-26-58.png); */
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 2px;
  }
}
</style>